import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TextUtils} from "../../../../../../shared/utils/text-utils";
import {AiBuilderService} from "../../../../ai-builder/service/ai-builder.service";
import {AbstractControl, FormControl} from "@angular/forms";
import {NotifierComponent} from "../../../../../../shared/components/notifier/notifier.component";
import {NotificationType} from "../../../../../../shared/components/notifier/notification-type";
import {Notification} from "../../../../../../shared/components/notifier/notification";
import {ReCaptchaV3Service} from "ngx-captcha";
import {Config} from "../../../../../../config/config";

@Component({
    selector: 'db-generate-with-ai',
    templateUrl: './generate-with-ai.component.html',
    styleUrls: ['./generate-with-ai.component.scss'],
    standalone: false
})
export class GenerateWithAiComponent implements OnInit {
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  @Output() showRegenerate: EventEmitter<void> = new EventEmitter<void>();
  @Input() control: AbstractControl;
  @Input() titleControl: AbstractControl;
  @Input() descriptionType: "short" | "long";
  @Input() generated = false;
  voiceControl = new FormControl('formal');
  keywordControl = new FormControl();
  loading = false;
  tonOfVoiceOptions = [
    {
      value: 'formal',
      label: TextUtils.getText('text_formal')
    },
    {
      value: 'informal',
      label: TextUtils.getText('text_informal')
    }
  ];



  constructor(private _builderService: AiBuilderService,
              private reCaptchaV3Service: ReCaptchaV3Service) {
  }

  ngOnInit() {
  }

  onGenerate() {
    if (this.generated) {
      this.close.emit();
      return;
    }

    this.generate();
  }

  onRegenerate() {
    this.generate();
  }

  generate() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.reCaptchaV3Service.execute(Config.googleRecaptcha, 'signup', (token) => {
      const data = {
        "store_description": this.keywordControl.value,
        "product_title": this.titleControl.value,
        "tone": this.voiceControl.value,
        "description_type": this.descriptionType,
        captcha_token: token
      };
      this._builderService.generateProductDescription(data)
        .subscribe(response => {
          if (!response) {
            return;
          }
          if (response.success && response.data) {
            this.control.setValue(response.data);
            this.generated = true;
            this.showRegenerate.emit();
          } else {
            NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
          }
          this.loading = false;
        });
    });
  }
}
